import {
	CORE_PROJECT,
	SERVICE_DESK_PROJECT,
	SOFTWARE_PROJECT,
} from '@atlassian/jira-common-constants';
import {
	COMPANY_MANAGED_PROJECT,
	TEAM_MANAGED_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types';

export const ProjectStyles = {
	COMPANY_MANAGED_PROJECT,
	TEAM_MANAGED_PROJECT,
} as const;

export type ProjectStyle = (typeof ProjectStyles)[keyof typeof ProjectStyles];

export const PROJECT_NAME_START_LIMIT = 2;
export const PROJECT_NAME_END_LIMIT = 80;

export const ProjectTypes = {
	BUSINESS: CORE_PROJECT,
	SOFTWARE: SOFTWARE_PROJECT,
	SERVICE_DESK: SERVICE_DESK_PROJECT,
} as const;

export const TemplateTypes = {
	SCRUM: 'jsw.scrum',
	KANBAN: 'jsw.kanban',
} as const;

export type TemplateType = (typeof TemplateTypes)[keyof typeof TemplateTypes];

export const PROJECT_KEY_LEARN_MORE_LINK =
	'https://support.atlassian.com/jira-core-cloud/docs/work-with-issues-in-jira-cloud/#Workingwithissues-Projectkeys';
